<template>
  <el-card >
    <!-- 查询条件表单 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="主题:"  >
        <el-input v-model="searchFactor.theme" ></el-input>
      </el-form-item>
      <el-form-item label="状态:" >
        <el-select style="width: 180px" v-model="searchFactor.active" placeholder="请选择" >
          <el-option
            v-for="item in actStateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="onSearch">查询</el-button>
      <el-button type="primary" @click="handleCreateLbt">创建轮播图</el-button>
    </el-form>
    <!-- 轮播图表格 -->
    <el-table
      :data="tableData"
      ref ="multipleTable"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%"
      class="tableClass">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="主题"
        min-width="150">
      </el-table-column>
      <el-table-column min-width="100px" prop="picture" label="图片">
        <template slot-scope="scope">
          <img :src="scope.row.imgUrl" fit="fill"  height="100"/>
        </template>
      </el-table-column>

      <el-table-column
        prop="outWebUrl"
        label="外部链接地址"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="active"
        min-width="70"
        label="状态" >
        <template slot-scope="scope">
          <span v-if = "scope.row.active == 1" style="color: greenyellow">  激活</span>
          <span v-else  style="color: red" > 禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createUsr"
        width="100"
        label="创建者">
      </el-table-column>
      <el-table-column
        prop="createTime"
        min-width="120"
        label="创建时间">
      </el-table-column>
      <el-table-column label="操作"  min-width="120px" >
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"active",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 1 ? 'el-icon-star-off':'el-icon-star-on' "  :style="scope.row.active == 1 ? 'color:rgb(246, 102, 18)':'color:rgb(40, 238, 10)'" ></i> 
                <span>{{scope.row.active == 1?'禁用':'激活'}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"delete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"edit",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(40, 238, 10)" ></i> <span>修改信息</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页插件 -->
    <el-pagination
      background
      height="200px"
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount">
    </el-pagination>
   
    
    <!-- 创建轮播图模块弹窗 -->
    <el-dialog :visible.sync="dialogVisual.createLbtInfoDialogVisible" v-on:close ="clearInitLbtForm" >
      <div slot="title" class="dialog-header">
        <span> 创建一个轮播图 </span>
      </div>
      <el-form :model="createLbtInfoForm" label-width="20%">
        <el-form-item   label="主题:"  style="width:90%" >
          <el-input  v-model="createLbtInfoForm.remark" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item  label="图片:" style="width:90%" >
          <el-upload
          :action="'#'"
          list-type="picture-card"
          :auto-upload="false"
          :ref="createLbtInfoForm.refElUpload"    
          :limit="createLbtInfoForm.limit">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file,createLbtInfoForm.refElUpload)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="createLbtInfoForm.dialogVisible">
          <img width="100%" :src="createLbtInfoForm.dialogImageUrl" alt />
        </el-dialog>
        </el-form-item>
        <el-form-item   label="链接外部地址:"  style="width:90%" >
          <el-input  v-model="createLbtInfoForm.outWebUrl" autocomplete="off" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建</el-button>
      </div>
    </el-dialog>

   <!-- 修改轮播图弹窗 -->
   <el-dialog :visible.sync="dialogVisual.editLbtInfoDialogVisible" v-on:close ="clearEditLbtForm" >
      <div slot="title" class="dialog-footer">
        <span> 修改轮播图 </span>
      </div>
      <el-form  label-position="right" label-width="20%" :model="editLbtInfoForm">
        <el-form-item style="width:80%" label="主题:">
          <el-input  v-model="editLbtInfoForm.remark" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item   label="链接外部地址:"  style="width:90%" >
          <el-input  v-model="editLbtInfoForm.outWebUrl" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item label="更新图片:" style="width:90%">
        <el-switch
          v-model="editLbtInfoForm.updateImage"
          active-text="是"
          inactive-text="否"  @change ="funcUpdateImageChange">
        </el-switch>
      </el-form-item>
      <el-form-item label="更新图片:" style="width:90%">
        <el-upload
          :action="'#'"
          list-type="picture-card"
          :auto-upload="false"
          :ref="editLbtInfoForm.refElUpload"    
          :file-list="editLbtInfoForm.fileListShow"
          :limit="editLbtInfoForm.limit">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file,editLbtInfoForm.refElUpload)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="editLbtInfoForm.dialogVisible">
          <img width="100%" :src="editLbtInfoForm.dialogImageUrl" alt />
        </el-dialog>
      </el-form-item>
    </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureEdit">确定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
import axios from  '@/api/axiosConfig'
import {stringIsNullOrEmpty,getToken} from  '@/api/utils'
import {PAGE_SIZE,MESSAGE_DURATION} from  '@/api/constant'

export default {
    name : 'pc_ctr_lbt',
    data() {
    return {
      tokenObj:{
        token :''
      },
      actStateOptions:[
        {  
          value: '',
          label: '全部'
        },
        {  
          value: '1',
          label: '激活'
        },
        { 
            value: '0',
            label: '禁用'
        }
      ],
      searchFactor: {
        theme: '',
        active: ''
      },
      tableData: [],
      pager:{
        totalCount:0,
        pageSize : PAGE_SIZE
      },
      dialogVisual:{
        editLbtInfoDialogVisible: false,
        createLbtInfoDialogVisible: false,
      },
      createLbtInfoForm: {
        remark: '',
        refElUpload :"lbtUpload",
        limit : 1,
        outWebUrl: '',
        param: new FormData(),
        dialogImageUrl:'',
        dialogVisible:false
      },
      editLbtInfoForm: {
        updateImage:false,
        remark: '',
        outWebUrl: '',
        refElUpload :"lbtEdit",
        limit : 1,
        id :'',
        fileListShow :[],
        row :''
      }
    }
  },
  
  methods : {
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'delete' :
            this.handleDelete(index,row)
            break
          case 'active' :
            this.handleActive(index,row)
            break
          case 'edit' :
            this.handleEdit(index,row)
            break
       
      }
    },
    // 生成表格编号
    indexMethod(index){
        return  index+1;
    },

    handleRemove(file,refElUpload) {
      let fileList = this.$refs[refElUpload].uploadFiles
      let index = fileList.indexOf(file)
      this.$refs[refElUpload].uploadFiles.splice(index,1)
    },

    // 格式化激活字段
    formatActive(row, index){
      if(row.active == 1){
          return "<span > 禁用 </span>";
      }else{
          return '激活';
      }
    },
    // 加载用户列表
    lbtListLoad(pageNo){
      let url = "/bc/exa/carousel/carouselPage"
      let { 
        theme,
        active 
      } =  this.searchFactor 
      
      let dat0 = {
        pageSize: PAGE_SIZE,
        theme,
        active,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          if(dat.data.length !== 0){
         
              this.tableData = []
              dat.data.forEach(t=>this.tableData.push(t))
              this.pager.totalCount = dat.totalDataCount
          } else {
            this.$message({
              showClose: true,
              message: '未查询轮播图信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    // 查询用户列表
    onSearch(){
      this.lbtListLoad(1)
    },
    // 打开创建用户弹框
    handleCreateLbt(){  
      this.dialogVisual.createLbtInfoDialogVisible = true
    },
    // 创建轮播图
    ensureCreate(){
      try{ 
        stringIsNullOrEmpty(this.createLbtInfoForm.remark,'请输入轮播图主题信息!');
        if(this.$refs[this.createLbtInfoForm.refElUpload].uploadFiles.length == 0){
          throw "请选择轮播图图片！"
        }
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      this.doCreateLbtInfo();
    },
    // 创建录播图
    doCreateLbtInfo(){
      if(this.createLbtInfoForm.param.has('file')){
        this.createLbtInfoForm.param.delete('file')
      }
      if(this.createLbtInfoForm.param.has('outWebUrl')){
        this.createLbtInfoForm.param.delete('outWebUrl')
      }
      if(this.createLbtInfoForm.param.has('remark') ){
        this.createLbtInfoForm.param.delete('remark')
      }
      let fileList = this.$refs[this.createLbtInfoForm.refElUpload].uploadFiles
      try{
        stringIsNullOrEmpty(this.createLbtInfoForm.remark,"主题信息不能为空")
        if(fileList == null || fileList.length == 0){
          throw "请选择轮播图图片"
        }
      }catch(e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return 
      }
   
      let file = fileList[0]
      this.createLbtInfoForm.param.append('outWebUrl', this.createLbtInfoForm.outWebUrl)
      this.createLbtInfoForm.param.append('file', file.raw)
      this.createLbtInfoForm.param.append('remark', this.createLbtInfoForm.remark)
      let url = "/bc/exa/carousel/carouselCreate"
      axios.post(url, this.createLbtInfoForm.param,{
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': this.tokenObj.token
        }
      }).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '创建轮播图成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.clearInitLbtForm()
          setTimeout(()=>{this.lbtListLoad(1)},200)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err)=> {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
      
    },
    // 关闭创建用户弹框
    clearInitLbtForm(){
      this.createLbtInfoForm.outWebUrl = ''
      this.createLbtInfoForm.remark = ''
      let fileObj = this.$refs[this.createLbtInfoForm.refElUpload]
      if(fileObj != null ){
        fileObj.clearFiles()
      }
    },
    clearEditLbtForm(){
      this.editLbtInfoForm.remark = ''
      this.editLbtInfoForm.outWebUrl = ''
      this.editLbtInfoForm.fileListShow.splice(0)
      let fileObj = this.$refs[this.editLbtInfoForm.refElUpload]
      if(fileObj != null ){
        fileObj.clearFiles()
      }
    },
    handleEdit(index, row){
      this.dialogVisual.editLbtInfoDialogVisible = true
      this.editLbtInfoForm.remark = row.remark
      this.editLbtInfoForm.outWebUrl = row.outWebUrl
      this.editLbtInfoForm.updateImage = false
      this.editLbtInfoForm.row = row
      this.editLbtInfoForm.id = row.id
      if(row.imgUrl != null && row.imgUrl != ''){

        this.editLbtInfoForm.fileListShow.push({name:row.id, url: row.imgUrl})
      }
     
    },
    funcUpdateImageChange(){

      let rawHasFile = false
      if(this.editLbtInfoForm.row != null && this.editLbtInfoForm.row != ''){
        rawHasFile = true
      }
      if(this.editLbtInfoForm.updateImage){
        if( this.$refs[this.editLbtInfoForm.refElUpload] != null){
          this.$refs[this.editLbtInfoForm.refElUpload].clearFiles()
        }
        if(rawHasFile){
          this.editLbtInfoForm.fileListShow.splice(0)
        }
      }else{
        if(rawHasFile){
          this.editLbtInfoForm.fileListShow.push({name:this.editLbtInfoForm.id, url: this.editLbtInfoForm.row.imgUrl})
        }
      }
    },
    ensureEdit(){
      this.$confirm('即将更新轮播图信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doEditLbtInfo()
      }).catch((e) => {
        this.$message({
          type: 'info',
          message: e
        });
      })
    },

    doEditLbtInfo(){
    
      let fileList = [] 
      try{
        if(this.editLbtInfoForm.updateImage){
          let fileRef = this.$refs[this.editLbtInfoForm.refElUpload]
          if(fileRef == null){
            throw "请选择轮播图图片"
          }
          fileList = fileRef.uploadFiles
          if(fileList == null || fileList.length == 0){
            throw "请选择轮播图图片"
          }
        }
      }catch(e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }

      let param  = new FormData()
      if(this.editLbtInfoForm.updateImage){
        let file = fileList[0]
        param.append('file', file.raw)
      }
      param.append('id', this.editLbtInfoForm.row.id) 
      param.append('outWebUrl', this.editLbtInfoForm.outWebUrl) 
      param.append('remark', this.editLbtInfoForm.remark) 
      let url = "/bc/exa/carousel/carouselEdit"
      axios.post(url, param,{
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': this.tokenObj.token
        }
      }).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.editLbtInfoDialogVisible = false
          this.$message({
            showClose: true,
            message: '修改轮播图成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.clearEditLbtForm()
          setTimeout(()=>{this.lbtListLoad(1)},200)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err)=> {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
      
    },
    handleCurrentChange(val){
      this.lbtListLoad(val);
    },
 
    handleDelete(index, row){
      this.$confirm('即将删除轮播图['+row.remark+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteLbtInfo(row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteLbtInfo(id){
      let url = "/bc/exa/carousel/carouselDelete"
      let dat = {id}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{this.lbtListLoad(1)},200)
          
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleActive(index, row){
      let actState = row.active === 0 ? 1 : 0
      let dat = {
        id: row.id,
        active: actState
      }
      let url = "/bc/exa/carousel/carouselActive"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
      if (response.data.code === 0){
        this.$message({
          showClose: true,
          message: '操作成功!',
          type: 'success',
          duration: MESSAGE_DURATION
        })
        this.lbtListLoad(1);
      } else {
        this.$message({
          showClose: true,
          message: response.data.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      }
    }).catch( (err)=> {
      this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
  },
  created () {
    setTimeout(()=>{getToken(this.tokenObj)},200)
    this.lbtListLoad(1);
  }
}
</script>
  
<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

</style>



// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_lbt.vue